import { AssignConfig } from "./assign-config";

export class AssignStrategy {
    constructor() {
        this.assignStrategy = 'ALL';
        this.assignConfig = new AssignConfig();
    }
    assignStrategy: string;
    assignConfig: AssignConfig;
}
